class PayPalPayFlow {
    constructor() {
        this.$paymentFormContainer = $('.payment-form')

        if (this.$paymentFormContainer.length <= 0) {
            return
        }

        this.$paymentForm = this.$paymentFormContainer.find('form')
        this.res_messages = {
            'FILL_REQUIRED_FIELDS': 'Please fill out all required fields',
            'GENERAL_ISSUE': 'An issue has occurred. Please try again!',
            'RECAPTCHA_VERIFICATION_FAILED': 'reCAPTCHA verification failed, please try again.'
        }

        this.init()
    }

    _resetForm() {
        this.$paymentForm[0].reset()
    }

    _showFormMessage(message) {
        const formMessage = this.res_messages[message] ? this.res_messages[message] : message
        this.$paymentFormContainer.find('.form-message').text(formMessage)
    }

    _showThankYou() {
        this.$paymentFormContainer.find('.thank-you').addClass('show')
        this.$paymentForm.remove()
    }

    _submitToPayPal() {
        $('#submit-paypal').click()
    }

    sendTransaction() {
        var isValid = this.validate()

        if (!isValid) {
            grecaptcha.reset()
            return
        }

        $.ajax({
            url: '/actions/payPalPayFlow/transactions/sendTransaction',
            type: 'POST',
            dataType: 'json',
            data: this.$paymentForm.serialize(),
            context: this,
            success: function(res) {
                if (res.status === 200) {
                    this._submitToPayPal()
                    return
                }

                grecaptcha.reset()
                this._showFormMessage(res.message)
            },
            error: function(err) {
                grecaptcha.reset()

                if (err.status === 403) {
                    this._showFormMessage('There was an error trying to send your message. Please try again.')
                    return
                }

                this._showFormMessage('Server is not responding. Please try again.')
            }
        })
    }

    validate() {
        const address = $('input[name="address"]').val()
        const amount = $('input[name="AMOUNT"]').val()
        const city = $('input[name="city"]').val()
        const company = $('input[name="company"]').val()
        const email = $('input[name="EMAIL"]').val()
        const employer = $('input[name="COMMENT2"]').val()
        const invoice = $('input[name="INVOICE"]').val()
        const name = $('input[name="NAME"]').val()
        const phone = $('input[name="PHONE"]').val()
        const policy = $('input[name="COMMENT1"]').val()
        const state = $('select[name="state"]').val()
        const zip = $('input[name="zip"]').val()

        if (
            !address || !amount || !city || !company ||
            !email || !employer || !invoice || !name ||
            !phone || !policy || !state || !zip
        ) {
            this._showFormMessage('FILL_REQUIRED_FIELDS')
            return false
        }

        return true
    }

    init() {
        window.PayPalPayFlow = this // This method is used in the _paymentForm.twig file
    }
}

export default PayPalPayFlow;
